// extracted by mini-css-extract-plugin
export default {"preLogin":"PreLogin_preLogin__VVlqY","rightsection":"PreLogin_rightsection__IOJaK","floatUpDown":"PreLogin_floatUpDown__jKFz6"};